import { apiSimple } from './api'

/**
 * Gera código de usuário para autenticação no iFood
 * @returns {Promise} Resposta com userCode, authorizationCodeVerifier, verificationUrl, etc
 */
export const generateUserCode = async () => {
  try {
    console.log('Gerando código de usuário iFood...');
    
    const response = await apiSimple.post('/ifood/generate-user-code');
    
    console.log('Código gerado com sucesso:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro detalhado ao gerar código:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Troca código de autorização por tokens e salva no banco (tudo em um)
 * @param {string} authorizationCode - Código fornecido pelo portal iFood
 * @param {string} authorizationCodeVerifier - Verificador gerado anteriormente
 * @param {string} storeId - ID da loja no iFood
 * @returns {Promise} Resposta com message de sucesso
 */
export const exchangeAuthorizationCode = async (authorizationCode, authorizationCodeVerifier, storeId) => {
  try {
    console.log('Trocando código por tokens e salvando...');

    const response = await apiSimple.post('/ifood/exchange-code', {
      authorizationCode,
      authorizationCodeVerifier,
      storeId
    });
    
    console.log('Integração concluída com sucesso:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro detalhado ao trocar código:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Valida o token do iFood para uma loja específica
 * @param {string} storeId - ID da loja
 * @returns {Promise} Resposta com status de validação do token
 */
export const validateToken = async (storeId) => {
  try {
    console.log('Validando token do iFood...');

    const response = await apiSimple.post('/ifood/validate-token', {
      storeId
    });
    
    console.log('Validação do token:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao validar token:', error.response?.data || error.message);
    throw error;
  }
};
